import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { Suspender } from 'src/Suspender';
// import AIAgentPage from 'src/Pages/AIAgent/AIAgentPage';

// Lazy load all page components
const Campaigns = lazy(() => import('pages/Campaigns/List'));
const CampaignDetail = lazy(() => import('pages/Campaigns/Detail/CampaignDetail'));
const SessionsList = lazy(() => import('pages/Sessions'));
const CampaignsCreate = lazy(() => import('pages/Campaigns/Create/CampaignsCreate'));
const SessionDetailPage = lazy(() => import('src/Pages/Session/SessionDetailPage'));
const CreateSession = lazy(() => import('src/Pages/Sessions/CreateSession'));
const CompendiumPicker = lazy(() => import('src/Pages/Compendium/CompendiumPicker'));
const CompendiumHome = lazy(() => import('src/Pages/Compendium/CompendiumHome'));
const CompendiumReview = lazy(() => import('src/Pages/Compendium/CompendiumReview'));
const EntityDossier = lazy(() => import('src/Pages/Compendium/EntityDossier'));
const CompendiumAccessGate = lazy(() => import('src/Pages/Compendium/CompendiumAccessGate'));
const ManageSubscription = lazy(() => import('src/Pages/ManageSubscription/ManageSubscription'));
const SubscriptionHandler = lazy(() => import('src/Pages/SubscriptionHandler'));
const Settings = lazy(() => import('src/Pages/Settings'));
const InAppNotFoundPage = lazy(() => import('src/Pages/NotFound/InAppNotFoundPage'));
const AdminPanel = lazy(() => import('pages/Admin/AdminPanel'));

interface AuthRoute {
  path: string;
  component: React.ComponentType;
  aiEnabled?: boolean;
}

export const AUTHED_ROUTES: Record<string, AuthRoute> = {
  HOME: {
    path: '/',
    component: () => <Navigate to="/campaigns" replace />,
    aiEnabled: true
  },
  CAMPAIGNS: {
    path: '/campaigns',
    component: () => (
      <Suspender>
        <Campaigns />
      </Suspender>
    ),
    aiEnabled: true
  },
  SESSIONS: {
    path: '/sessions',
    component: () => (
      <Suspender>
        <SessionsList />
      </Suspender>
    ),
    aiEnabled: true
  },
  CREATE_CAMPAIGN: {
    path: '/campaigns/create',
    component: () => (
      <Suspender>
        <CampaignsCreate />
      </Suspender>
    ),
    aiEnabled: true
  },
  CAMPAIGN_DETAIL: {
    path: '/campaigns/:campaignId',
    component: () => (
      <Suspender>
        <CampaignDetail />
      </Suspender>
    ),
    aiEnabled: true
  },
  COMPENDIUM_PICKER: {
    path: '/compendium',
    component: () => (
      <Suspender>
        <CompendiumAccessGate>
          <CompendiumPicker />
        </CompendiumAccessGate>
      </Suspender>
    ),
    aiEnabled: true
  },
  COMPENDIUM_HOME: {
    path: '/compendium/:campaignId',
    component: () => (
      <Suspender>
        <CompendiumAccessGate>
          <CompendiumHome />
        </CompendiumAccessGate>
      </Suspender>
    ),
    aiEnabled: true
  },
  COMPENDIUM_REVIEW: {
    path: '/compendium/:campaignId/review',
    component: () => (
      <Suspender>
        <CompendiumAccessGate>
          <CompendiumReview />
        </CompendiumAccessGate>
      </Suspender>
    ),
    aiEnabled: true
  },
  COMPENDIUM_ENTITY: {
    path: '/compendium/:campaignId/:slug',
    component: () => (
      <Suspender>
        <CompendiumAccessGate>
          <EntityDossier />
        </CompendiumAccessGate>
      </Suspender>
    ),
    aiEnabled: true
  },
  SESSION_TRANSCRIPT: {
    path: '/sessions/:sessionId/transcript',
    component: () => (
      <Suspender>
        <SessionDetailPage />
      </Suspender>
    ),
    aiEnabled: true
  },
  CREATE_SESSION: {
    path: '/campaigns/:campaignId/sessions/create',
    component: () => (
      <Suspender>
        <CreateSession />
      </Suspender>
    ),
    aiEnabled: true
  },

  SETTINGS: {
    path: '/settings',
    component: () => (
      <Suspender>
        <Settings />
      </Suspender>
    ),
    aiEnabled: false
  },

  ADMIN: {
    path: '/admin',
    component: () => (
      <Suspender>
        <AdminPanel />
      </Suspender>
    ),
    aiEnabled: false
  },

  MANAGE_SUBSCRIPTION: {
    path: '/manage-subscription',
    component: () => (
      <Suspender>
        <ManageSubscription />
      </Suspender>
    ),
    aiEnabled: false
  },

  SUBSCRIPTION: {
    path: '/subscription',
    component: () => (
      <Suspender>
        <SubscriptionHandler />
      </Suspender>
    ),
    aiEnabled: false
  },

  NOT_FOUND: {
    path: '/not-found',
    component: () => (
      <Suspender>
        <InAppNotFoundPage />
      </Suspender>
    ),
    aiEnabled: false
  }
};
